import { filterNumbers } from './common';

const cardTypeRegEx = {
  UNIONPAY: /^62[\d]{14,17}$/,
  VISAELECTRON: /^(400115|400837|400838|400839|412921|412922|412923|417935|419740|419741|419773|419774|419775|424519|424962|424963|437860|444000|459472|484406|484407|484408|484409|484410|484411|484413|484414|484418|484419|484420|484421|484422|484423|484424|484425|484426|484428|484429|484430|484431|484432|484433|484434|484435|484436|484437|484438|484439|484440|484441|484442|484443|484444|484445|484446|484447|484448|484449|484450|484451|484452|484453|484454|484455|491730|491731|491732|491733|491734|491735|491736|491737|491738|491739|491740|491741|491742|491743|491744|491745|491746|491747|491748|491749|491750|491751|491752|491753|491754|491755|491756|491757|491758|491759|400121|401773|428384)[\d]{10}$/,
  MAESTRO: /^(5[0678][\d]{10,17}|639[\d]{9,16}|67[\d]{10,17})$/,
  DISCOVER: /^(6011[\d]{12,15}|6[4-5][\d]{14,17}|36[\d]{12,17}|30[0-5][\d]{13,16}|3095[\d]{12,15}|3[8-9][\d]{14,17})$/,
  AMEX: /^3[47][\d]{13}$/,
  MASTER_CARD: /^(222[1-9][\d]{12}|22[3-9][\d]{13}|2[3-6][\d]{14}|271[\d]{13}|2720[\d]{12}|5[1-5][\d]{14})$/,
  VISA: {
    test: (pattern, flags) => !cardTypeRegEx.VISAELECTRON.test(pattern, flags) && /^4([\d]{12}|[\d]{15})$/.test(pattern, flags),
  },
  JCB: /^(352[8-9][\d]{12,15}|35[3-8][\d]{13,16})$/,
};

/**
 * Wiki: https://en.wikipedia.org/wiki/Luhn_algorithm
 * @param string cardNumber
 */
const validatorCardValue = (cardNumber) => {
  const modeNumber = number => (number >= 10 ? number - 9 : number);
  return cardNumber && cardNumber.split('').reverse().map(n => parseInt(n, 10))
    .reduce((acc, number, idx) => acc + (idx % 2 ? modeNumber(number * 2) : number), 0) % 10 === 0;
};

const INVALID = 'INVALID';
const identifyCardTypeBuilder = (cardTypes = []) => (cardNumber) => {
  const isMatchedType = cardType => cardTypes.indexOf(cardType) > -1 && cardTypeRegEx[cardType].test(cardNumber);
  return (validatorCardValue(cardNumber) && Object.keys(cardTypeRegEx).reduce((acc, cardType) => (
    acc || (isMatchedType(cardType) ? cardType : undefined)
  ), undefined)) || INVALID;
};

const getCardCurrentType = (cardTypes, value) => {
  const identifyCardType = identifyCardTypeBuilder(cardTypes);
  return identifyCardType(filterNumbers(value));
};

const cvvValidator = (i18n, value) => {
  const RegEx = /^(\d{3}|\d{4})$/;
  if (!RegEx.test(value)) {
    return i18n('checkout.lib.components.error.validate.cvv');
  }
  return '';
};

const cardNumberValidator = (cardTypes, i18n, callBack, value) => {
  const cardType = getCardCurrentType(cardTypes, value);
  callBack(cardType);
  if (cardType === INVALID) {
    return i18n('checkout.lib.components.error.validate.cardNumber');
  }
  return '';
};

const holderNameValidator = (i18n, value) => {
  const RegEx = /^[^0-9]+$/g;
  if (!RegEx.test(value)) {
    return i18n('checkout.lib.components.newCreditCard.validate.holderName');
  }
  return '';
};

export {
  getCardCurrentType,
  cvvValidator,
  cardNumberValidator,
  holderNameValidator,
};
